import React, { ReactNode, useEffect, useState } from 'react';
import styles from '../styles/button.module.scss';

type ButtonColors =
  | 'green'
  | 'red'
  | 'blue'
  | 'peach'
  | 'transparent'
  | 'default';

export default function Button(props: {
  children: ReactNode;
  onClick: () => void;
  color?: ButtonColors;
  icon?: ReactNode;
  loading?: boolean;
  timer?: number;
  bordered?: boolean;
}) {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (!props.timer) return;
    let intervalProgress = progress;
    const interval = setInterval(() => {
      if (intervalProgress < 0) {
        props.onClick();
        clearInterval(interval);
      } else {
        setProgress(intervalProgress--);
      }
    }, props.timer);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <button
      className={styles.button}
      style={{
        background: gradientBg(props.color || 'default'),
        border: props.bordered ? '2px solid #fff' : 'none',
      }}
      onClick={props.onClick}
    >
      {props.icon}
      <span>{props.children}</span>
      {props.timer && (
        <div
          className={styles.button__progress}
          style={{ right: `${progress}%` }}
        />
      )}
    </button>
  );
}

const gradientBg = (color: ButtonColors): string => {
  if (color === 'default')
    return `linear-gradient(180deg, #78CC6F 0%, #296726 100%)`;

  const backgrounds: Record<ButtonColors, [string, string]> = {
    default: ['#78CC6F', '#296726'],
    peach: ['#F78D5C', '#EF7B45'],
    green: ['#77B28C', '#56936C'],
    red: ['#CE595B', '#BC4749'],
    blue: ['#1283AA', '#086788'],
    transparent: ['transparent', 'transparent'],
  };
  return `linear-gradient(141.99deg, ${backgrounds[color][0]} 18.96%, ${backgrounds[color][1]} 74.27%)`;
};
